import createPMRoute from "discourse/routes/build-private-messages-route";

export default createPMRoute("user", "private-messages-sent", "sent");
